import styled from 'styled-components';
import { ReactComponent as ReferralSvg } from '../../assets/icons/referral.svg';
import { Text14Bold, Text14Light, Text16Light, Text19Light } from '../../components/utils/Text/Text.styles';
import { Button } from '../../components/utils/Button/Button';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 42rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
    padding-bottom: 6rem;
  }
`;

export const ReferralIcon = styled(ReferralSvg)`
  margin-bottom: 1.6rem;
`;

export const SubtitleText = styled(Text14Bold)`
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.14px;
  width: 30rem;
  margin-top: 1.2rem;
  margin-bottom: 0.4rem;
  text-align: center;
`;

export const Text = styled(Text14Light)`
  line-height: 22px;
  text-align: center;
  width: 36.6rem;
  margin-bottom: 3.6rem;
`;

export const OrText = styled(Text14Light)`
  opacity: 0.1;
  line-height: 22px;
  margin-bottom: 1.4rem;
`;

export const InviteButton = styled(Button)`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, var(--Blue-500, #3e9be4) 6.75%, var(--Blue-700, #1672ba) 93.25%);
  padding: 1.2rem;
  font-size: 1.4rem;
  font-weight: 400;
  width: 15rem;
`;

export const InfoText = styled(Text16Light)`
  line-height: 22px;
  padding-left: 6.6rem;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 4.4rem;
`;

export const NoteText = styled(Text19Light)`
  line-height: 26px;
  color: #1a88df;
  padding-left: 6.6rem;
  margin-top: 3.2rem;
  margin-right: 9rem;
`;
